import {PullRequestStateIcons} from '@github-ui/issue-pr-state/Icons'
import type {PullRequestPickerPullRequest} from '@github-ui/item-picker/PullRequestAndBranchPicker'
import {getPrState} from '@github-ui/item-picker/PullRequestAndBranchPicker'
import {ActionList} from '@primer/react'

import styles from './LinkedPullRequests.module.css'

type LinkedPullRequestsProps = {
  linkedPullRequests: PullRequestPickerPullRequest[]
}

export function LinkedPullRequests({linkedPullRequests}: LinkedPullRequestsProps) {
  return (
    <>
      {linkedPullRequests.map(pullRequest => {
        return (
          <ActionList.LinkItem
            href={pullRequest.url}
            target="_blank"
            key={pullRequest.id}
            className={styles.ActionList_LinkItem}
          >
            <ActionList.LeadingVisual>{getPrIcon(pullRequest)}</ActionList.LeadingVisual>
            {pullRequest.title}
            <ActionList.Description variant="block">{pullRequest.repository.nameWithOwner}</ActionList.Description>
          </ActionList.LinkItem>
        )
      })}
    </>
  )
}

function getPrIcon(pullRequest: PullRequestPickerPullRequest) {
  const prState = getPrState(
    pullRequest.isDraft && pullRequest.state === 'OPEN',
    pullRequest.isInMergeQueue,
    pullRequest.state,
  )
  const Icon = PullRequestStateIcons[prState]
  return <Icon />
}

try{ LinkedPullRequests.displayName ||= 'LinkedPullRequests' } catch {}